



































import { EventBus } from "@/event-bus";
import {
  DefaultPickupDataDefModal,
  ManagePickupRequestDTO,
  PickupDTO
} from "@/model/data.model";
import { ShipmentService } from "@/services/ShipmentService";
import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";
import Modal from "../shared/modal/Modal.vue";
import ModalCPMContent from "./ModalCPMContent.vue";
import { AlertBus } from "@/plugins/alerts/AlertBus";
import { Validations } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import { MBEShipServiceBusiness } from "@/model/enumeration.model";

@Component({
  components: {
    MbeModal: Modal,
    ModalContent: ModalCPMContent
  }
})
export default class ModalCPMEdit extends Vue {
  @Prop({})
  shipment: any;
  @Prop({ default: false })
  showAdditionalActions: boolean; // show additional action like senddata and delete pickup
  @Prop({})
  toggle: Function;
  @Prop({})
  couriers: any[];
  @Prop({})
  mol: boolean;
  @Prop({ default: true })
  showSender: boolean;
  @Prop({ default: false })
  editMode: boolean;
  @Prop({})
  itemSelected: any;
  @Prop({})
  goEditable: boolean;
  pickupData: DefaultPickupDataDefModal = {
    note: "",
    time: [],
    alternativeTime: [],
    date: new Date()
  };
  @Emit("selected-documents-zero")
  setSelectedDocumentsZero() {
    return;
  }

  @Validations()
  validations() {
    return {
      pickupData: {
        required,
        note: { required },
        time: { required },
        alternativeTime: { required },
        date: { required }
      }
    };
  }

  created() {
    this.initializePickupData();
  }
  initializePickupData() {
    if (this.itemSelected.pickup) {
      this.pickupData.time.push(
        this.stringToDate(this.itemSelected.pickup.preferredFrom || "00:00"),
        this.stringToDate(this.itemSelected.pickup.preferredTo || "00:00")
      );
      this.pickupData.alternativeTime.push(
        this.stringToDate(this.itemSelected.pickup.alternativeFrom || "00:00"),
        this.stringToDate(this.itemSelected.pickup.alternativeTo || "00:00")
      );
      this.pickupData.date = this.itemSelected.pickup.pickupDate;
      this.pickupData.note = this.itemSelected.pickup.note;
    }
  }

  closeModal() {
    this.$emit("closeModal");
  }

  stringToDate(value: string) {
    const timeParts = value.split(":");
    const finalDate = new Date(
      2024,
      12,
      12,
      Number(timeParts[0]),
      Number(timeParts[1])
    );
    return finalDate;
  }

  formatPickupForm() {
    this.itemSelected.pickup.alternativeFrom = moment(
      new Date(this.pickupData.alternativeTime[0])
    ).format("HH:mm");
    this.itemSelected.pickup.alternativeTo = moment(
      new Date(this.pickupData.alternativeTime[1])
    ).format("HH:mm");
    this.itemSelected.pickup.preferredFrom = moment(
      this.pickupData.time[0]
    ).format("HH:mm");
    this.itemSelected.pickup.preferredTo = moment(
      this.pickupData.time[1]
    ).format("HH:mm");
    this.itemSelected.pickup.pickupDate = this.pickupData.date;
    this.itemSelected.pickup.note = this.pickupData.note;
  }

  shipmentAction(action: string) {
    if (action === "CREATE_AND_PROCESS") {
      this.formatPickupForm();
    }

    const pickupObjDTO: PickupDTO = {
      bookingIdentificationNumber: this.itemSelected.pickup
        .bookingIdentificationNumber,
      pickupDate: this.itemSelected.pickup.pickupDate,
      note: this.itemSelected.pickup.note,
      alternativeFrom: this.itemSelected.pickup.alternativeFrom,
      alternativeTo: this.itemSelected.pickup.alternativeTo,
      checksum: "",
      creationDate: this.itemSelected.pickup.creationDate,
      deleted: false, //dopo la chiamata diventa true
      preferredFrom: this.itemSelected.pickup.preferredFrom,
      preferredTo: this.itemSelected.pickup.preferredTo,
      rejectedReason: "",
      requestLocation: "",
      status: "PENDING"
    };
    const pickupObj: ManagePickupRequestDTO = {
      shipmentIdList: [this.itemSelected.shipmentId],
      pickupDto: pickupObjDTO
    };
    ShipmentService.manageCourierPickup(action, pickupObj)
      .then(res => {
        const messages = res.shipmentPickupErrorList;
        if (messages && messages.length > 0) {
          // There are some errors
          let title = "<ul>";
          res.shipmentPickupErrorList.forEach(error => {
            const listId = Object.keys(error);

            listId.forEach((id: any) => {
              title += "<li>" + error[id] + "</li>";
            });
          });
          let message = "<h5>" + this.$t("FIX_BEFORE_CONTINUE") + "</h5></br>";
          message += title + "</ul>";
          return AlertBus.$alerts.danger(message);
        } else {
          this.$notify.success(this.$t("changes_saved"));
          this.closeModal();
          this.setSelectedDocumentsZero();
          EventBus.$emit("search-on-pickup-management");
        }
      })
      .catch(err => {
        this.$notify.error(err.response.data.message);
      });
  }

  get isGel() {
    return (
      this.itemSelected.mbeServiceId ===
        MBEShipServiceBusiness.GEL_PROXIMITY_POINT ||
      this.itemSelected.mbeServiceId === MBEShipServiceBusiness.MBE_ACCESS_POINT
    );
  }
}
